import { render, staticRenderFns } from "./login_header.vue?vue&type=template&id=2270b97d&scoped=true&"
import script from "./login_header.vue?vue&type=script&lang=js&"
export * from "./login_header.vue?vue&type=script&lang=js&"
import style0 from "./login_header.vue?vue&type=style&index=0&id=2270b97d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270b97d",
  null
  
)

export default component.exports